module.exports = __webpack_public_path__ + "static/media/s2.26e36285.jpg";